// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Import(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Import" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 13.4963H13.6669L16.9073 16.9227L14.8891 19.0254L8.28596 12.0443L14.9673 4.98411L16.9812 7.0868L13.7422 10.5117H22.5L22.5 13.4963Z", fill: "currentColor" }),
            React.createElement("path", { d: "M10.5 1.5H1.5V22.5H10.5V19.5H4.5V4.5H10.5V1.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Import.js.map